import React from 'react';
import { Button } from 'tuui';
import { FormField } from 'taboola-ultimate-ui';
import { useNavigate } from 'hooks';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import { COMBINED_AUDIENCES_REPORT_ID } from '../../../campaigns/modules/campaigns-reports/config/reports/combined-audience/combinedAudiencesReportId';
import { CUSTOM_CONTEXTUAL_REPORT_ID } from '../../../campaigns/modules/campaigns-reports/config/reports/custom-contextual/customContextualReportId';
import { FIRST_PARTY_REPORT_ID } from '../../../campaigns/modules/campaigns-reports/config/reports/first-party/firstPartyReportId';
import { PREDICTIVE_REPORT_ID } from '../../../campaigns/modules/campaigns-reports/config/reports/lookalike/predictiveReportId';
import { MAIL_DOMAINS_REPORT_ID } from '../../../campaigns/modules/campaigns-reports/config/reports/mail-domains/mailDomainsReportId';
import { PIXEL_BASED_REPORT_ID } from '../../../campaigns/modules/campaigns-reports/config/reports/pixel-based/pixelBasedReportId';
import { SEARCH_KEYWORDS_REPORT_ID } from '../../../campaigns/modules/campaigns-reports/config/reports/search-keywords/searchReportsReportId';
import { useModal } from '../../../taboola-common-frontend-modules/modals';
import { AudiencesCreatorSelectionPage } from '../../pages/AudiencesCreatorSelectionPage';
import {
    generateMailDomainAudiencesCreatorPath,
    generatePredictiveAudienceCreatorPath,
    generateSearchKeywordsAudiencesCreatorPath,
    generateFirstPartyAudienceCreatorPath,
    generatePixelBasedAudienceCreatorPath,
    generateCustomContextualCreatorPath,
    generateCombinedAudienceCreatorPath,
} from '../../utils/generateCreatorPath';
import styles from './createAudienceButton.module.scss';

const paths = {
    [PIXEL_BASED_REPORT_ID]: generatePixelBasedAudienceCreatorPath(),
    [PREDICTIVE_REPORT_ID]: generatePredictiveAudienceCreatorPath(),
    [FIRST_PARTY_REPORT_ID]: generateFirstPartyAudienceCreatorPath(),
    [CUSTOM_CONTEXTUAL_REPORT_ID]: generateCustomContextualCreatorPath(),
    [MAIL_DOMAINS_REPORT_ID]: generateMailDomainAudiencesCreatorPath(),
    [SEARCH_KEYWORDS_REPORT_ID]: generateSearchKeywordsAudiencesCreatorPath(),
    [COMBINED_AUDIENCES_REPORT_ID]: generateCombinedAudienceCreatorPath(),
};
const CreateAudienceButton = () => {
    const navigate = useNavigate();
    const { open: openModal } = useModal();
    const openModalDialog = async () => {
        const audienceCreationType = await openModal({
            title: (
                <FormField
                    label={
                        <FormattedMessage id="app.modal.createAudience.title" defaultMessage="Select Audience Type" />
                    }
                />
            ),
            contentRenderer: AudiencesCreatorSelectionPage,
            className: styles['modal'],
        });
        if (audienceCreationType) {
            navigate(paths[audienceCreationType]);
        }
    };

    return (
        <Button className={styles['button']} onClick={openModalDialog}>
            <FormattedMessage id="app.gridToolbar.create.audience" defaultMessage="+ New Audience" />
        </Button>
    );
};

export default CreateAudienceButton;
